import { Routes } from '@angular/router';

export const RentDepositStepRoutes: Routes = [
  {
    path: 'personalInformation',
    loadComponent: () =>
      import('./rent-deposit-personal-information/rent-deposit-personal-information.component').then(
        m => m.RentDepositPersonalInformationComponent
      ),
    title: 'rent_deposit.wizard.personal_information_title_l'
  },
  {
    path: 'object',
    loadComponent: () =>
      import('./rent-deposit-object/rent-deposit-object.component').then(
        m => m.RentDepositObjectComponent
      ),
    title: 'rent_deposit.wizard.object_title_l'
  },
  {
    path: 'payment',
    loadComponent: () =>
      import('./rent-deposit-payment/rent-deposit-payment.component').then(
        m => m.RentDepositPaymentComponent
      ),
    title: 'rent_deposit.wizard.payment_title_l'
  },
  {
    path: 'summary',
    loadComponent: () =>
      import('./rent-deposit-summary/rent-deposit-summary.component').then(
        m => m.RentDepositSummaryComponent
      ),
    title: 'rent_deposit.wizard.summary_title_l'
  }
];
